import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { NumericInputComponent } from '../../../../views/shared/components/form-components/numeric-input/numeric-input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-table-header-number-input',
  standalone: true,
  imports: [],
  templateUrl: '../../../../views/shared/components/form-components/numeric-input/numeric-input.component.html',
  styleUrls: ['./table-header-number-input.component.scss', '../table-column-inputs.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TableHeaderNumberInputComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class TableHeaderNumberInputComponent extends NumericInputComponent {
  @Input() placeholder: string = $localize`Search`;
}
